import React, { useState } from 'react';
import { Table, DateTimeUtils } from 'dyl-components';
import { Icon } from 'semantic-ui-react';
import SessionSubTable from './SessionSubTable';
import { useDispatch } from 'react-redux';
import campaignSessionSummaryActions from 'actions/campaign_session_summary';
import { useParams } from 'react-router-dom';
import { PhoneUtil, StringUtils } from 'utils';

const UserStats = ({ session_id }) => {
    return (
        <Table.CollapsibleRowContent>
            <Table.Cell colSpan={8}>
                <SessionSubTable session_id={session_id} />
            </Table.Cell>
        </Table.CollapsibleRowContent>
    )
}

const SessionRow = ({ session }) => {
    const [isExpanded, setExpanded] = useState(false);
    const dispatch = useDispatch();
    const { id } = useParams();
    const session_id = session.id;
    const onToggleRow = () => {
        setExpanded(!isExpanded);
        if (!isExpanded) {
            dispatch(campaignSessionSummaryActions.readDialerSession(id, null, session_id));
        }
    };
    return (
        <Table.CollapsibleRow
            collapsed={!isExpanded}
            onToggle={onToggleRow}
            subrowContent={<UserStats session_id={session_id} session={session} />}
        >
            <Table.Cell>
                <div><b>{DateTimeUtils.formatEpoch(session.start, DateTimeUtils.WORD_DATE_FORMAT)}</b></div>
                <div>{DateTimeUtils.formatEpoch(session.start, DateTimeUtils.TIME_FORMAT)}</div>
            </Table.Cell>
            <Table.Cell>{session.called ?? '0'}</Table.Cell>
            <Table.Cell>
                {session.ndnc ?? '0'}
            </Table.Cell>
            <Table.Cell>
                {session.dnc ?? '0'}
            </Table.Cell>
            <Table.Cell>
                {session.time ? PhoneUtil.timeTicker(session.time) : ""}
            </Table.Cell>
            <Table.Cell>
                <Icon onClick={() => {
                    dispatch(campaignSessionSummaryActions.readDialerSession(id, null, session_id)).then(users => {
                        const csv = StringUtils.jsonToCsv(users.map(user => ({
                            "User": `${user.first_name} ${user.last_name}`,
                            "# Calls": user.call_info?.total ?? 0,
                            "Total Call Time": user.call_info?.talk_time ? PhoneUtil.timeTicker(user.call_info?.talk_time) : "00:00:00",
                            "Connected": user.call_info?.connected ?? 0,
                            "Not Connected": user.call_info?.notconnected ?? 0,
                            "Voicemail Drop": user.call_info?.voicemail_drop ?? 0,
                            "Disconnected": user.call_info?.disconnected ?? 0,
                            "Missed Attempt": user.call_info?.missedattempt ?? 0,
                            "No-Answer": user.call_info?.notanswered ?? 0,
                            "Busy": user.call_info?.busy ?? 0,
                            "Transferred": user.call_info?.transfer ?? 0,
                            "Abandoned": user.call_info?.abandoned ?? 0,
                            "Missed": user.call_info?.missed ?? 0
                        })));
                        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        link.download = `session${session_id}_${DateTimeUtils.formatEpoch(session.start, `${DateTimeUtils.CALENDAR_API_DATE_FORMAT}--hh_mm-A`)}.csv`;
                        link.click();
                    });
                }} className='fas fa-download' color='primary' link />
            </Table.Cell>
        </Table.CollapsibleRow>
    );
};

export default SessionRow;
